import { Component, OnInit, Input, ViewChild, Output } from '@angular/core';
import { StoreService } from '../../../_services';
import { PopoverInput } from '../base/popover-input';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import * as _ from 'lodash';

@Component({
	selector: 'popover-multiple-store-select-typeahead',
	template: require('./popover-multiple-store-select-typeahead.component.html')
})
export class PopoverMultipleStoreSelectTypeaheadComponent extends PopoverInput implements OnInit {

    constructor(private storeService: StoreService) { super(); }

	ngOnInit() {
		this.storeService.getStoreList().then(result => this.storeList = result.map(x => ({
			id: x.id,
			name: x.storeCode + " " + x.popularName,
			region: x.region.countryCode + " · "  + x.region.name,
			popularName: x.popularName,
			storeCode: x.storeCode
		})));
	}



	@Input('value')
	set setValue(val: any) {
		this.originalValue = Array.from(val);
		this.dirtyValue = val;

	}

	get hasChanges() { return !_.isEqual(this.originalValue, this.dirtyValue); }

	public selected: any;
	public storeList: any[];

	public getStores(list: number[]) {

		if (!!list && !!this.storeList) {
			return list.map(s => this.storeList.find(x => x.id === s)).filter(x => !!x);
		}

		return null;

	}

	public onDelete (e, s: number) {

		e.stopPropagation();

		var index = this.dirtyValue.indexOf(s, 0);
		if (index > -1) {
			this.dirtyValue.splice(index, 1);
		}

	}

	public onSelect(e: TypeaheadMatch): void {
	
		if (!!e.item) {
			this.dirtyValue.unshift(e.item.id);
			this.dirtyValue = _.uniq(this.dirtyValue);
			this.selected = "";

		}

	}


}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/editable-popover/specialized/popover-multiple-store-select-typeahead.component.ts